import { Message, Conversation } from "../types";

export function handleMessages(
  messages: Message[],
  startTimestamp: number,
  endTimestamp: number
): Record<string, Conversation> {
  const conversations: Record<string, Conversation> = {};

  messages.forEach((message) => {
    if (!conversations[message.phone]) {
      conversations[message.phone] = {
        phone: message.phone,
        messages: [],
      };
    }
    conversations[message.phone].messages.push(message);
  });

  Object.values(conversations).forEach((conversation) => {
    conversation.messages.sort((a, b) => a.timestamp - b.timestamp);

    if (conversation.messages.length > 0) {
      conversation.lastMessage =
        conversation.messages[conversation.messages.length - 1];
    }
  });

  return conversations;
}

export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber;

  const cleaned = ("" + phoneNumber).replace(/\D/g, "");

  const match = cleaned.match(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/);

  if (match) {
    return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
  }

  return phoneNumber;
}

export function toSeconds(date: Date | string): number {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return Math.floor(dateObj.getTime() / 1000);
}
